import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import Form from 'react-bootstrap/Form';
import { MdClear, MdSearch } from 'react-icons/md';
import { FaCalendarAlt, FaPrint } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import DatePicker from 'react-datepicker';
import Spinner from 'react-bootstrap/Spinner';

import "react-datepicker/dist/react-datepicker.css";
import { API } from 'aws-amplify';
import moment from 'moment';

import { useToasts } from 'react-toast-notifications';

import "./RedLightSpeedDet.scss";

import VehClass from './VehClass';
import DetZone from './DetZone';

import RedLightSpeedDetXls from './RedLightSpeedDetXls';

const params = {
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

const RedLightSpeedDet = (props) => {
    const { addToast } = useToasts();

    const [vehicleClass, setVehicleClass] = useState({});
    const [vehicleClassTbl, setVehicleClassTbl] = useState([]);
    const [asset, setAsset] = useState();
    const [assetName, setAssetName] = useState();
    const [assets, setAssets] = useState([]);
    const [timeFrom, setTimeFrom] = useState(new Date().setHours(0,0,0));
    const [timeTo, setTimeTo] = useState(new Date().setHours(23,59,0));
    const [dateSel, setDateSel] = useState(new Date());
    const [dateSelTo, setDateSelTo] = useState(new Date());
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingCounts, setIsLoadingCounts] = useState(false);
    const [counts, setCounts] = useState([]);
	const [location, setLocation] = useState('');
	const [locationList, setLocationList] = useState([]);
	const [assetList, setAssetList] = useState([]);
    const [countryList, setCountryList] = useState([]);
	const [country, setCountry] = useState('');
    const [RLDstat, setRLDstat] = useState([]);
    const [RLDdet, setRLDdet] = useState([]);

    const chartColors = process.env.REACT_APP_CHART && process.env.REACT_APP_CHART.split(',');   

    let formatDate = ['DD-MM-YYYY','dd/MM/yyyy','DD/MM/YYYY, h a']
    if (props.formatDate!==formatDate[0]){
        formatDate = ['MM-DD-YYYY','MM/dd/yyyy','MM/DD/YYYY, h a']
    }

    // const sum = (arr) => arr.reduce((a, b) => a + b, 0);
    // const count_non_zeros = (arr) => arr.reduce((a, b) => b > 0 ? a + 1 : a, 0);
    // const avg_excluding_zeros = useCallback((arr) => {
    //     if (arr.length === 0) {
    //       return 0;
    //     }
    //     const non_zeros = count_non_zeros(arr);
    //     if (non_zeros === 0) {
    //       return 0;
    //     }
    //     return parseFloat((sum(arr) / non_zeros).toFixed(2));
    //   },[]);

    // Load asset
    /* eslint-disable no-alert, no-console */
    useEffect(()=>{
        const fetchAssets = async () => {
            setIsLoading(true);


            let data = await API.get('asset','/', params)
            data.sort((a, b) => (a.name > b.name) ? 1 : -1)
            
            // filter assets with the red light speed funtionality 
            data = data.filter(x => x.red_light_last_update)

            //Get user asset list
            // let user_assets = []
            // if (props.user && props.user.username)
            //     user_assets = await API.get('user_assets','/' + props.user.username, params)
            let user_assets = props.user.user_assets || []

            let assetsFiltered = []
            if (user_assets){
                // user_assets = user_assets.assets;
                assetsFiltered = data.filter(x => user_assets.find(i => i === x.id));
            }


            if (assetsFiltered.length>0){
                setAssets(assetsFiltered);
                setAssetList(assetsFiltered);
            }

            setIsLoading(false);
        }

    if (props.user && props.user.user_assets)
        fetchAssets();

    }, [props.user]);

    // Load counts
    // Fetch hourly counts filter by asset, date and time range
    const fetchCounts = async () => {
        setIsLoadingCounts(true);
        const dtF = new Date(dateSel)
        const dtT = new Date(dateSel)

        const dtFrom = moment.utc(dtF).local().format('YYYY-MM-DD')
        const tiFrom = moment.utc(timeFrom).local().format('HH:mm:ss');
        let  dateStart = moment(dtFrom + ' ' + tiFrom).toISOString();

        const dtTo = moment.utc(dtT).local().format('YYYY-MM-DD')
        const tiTo = moment.utc(timeTo).local().format('HH:mm:ss');
        let  dateEnd = moment(dtTo + ' ' + tiTo).toISOString();


        if (dateEnd >= dateStart){
            // console.log("dateEnd",dateEnd)
            // console.log("dateStart",dateStart)
            const filter = asset +'?start='+ dateStart +'&end='+ dateEnd

            let data = []
            await API.get('hourly_counts','/'+ filter, params)
            .then(resp => {
                data = resp
            }).catch(error => {
                console.log(error)
                addToast('Error Loading Data', { appearance: 'error' });
                setIsLoadingCounts(false);
            });

            const dataFiltered = data.map((item, i) => {
                let zones = []
                let row = []
                    // Format array [{asset, date, entries}]
                    Object.keys(item).forEach((key) => {
                        if (typeof item[key] === 'object' && item[key] !== null) {
                        zones.push(item[key])
                        }
                    })
                    // console.log(zones)
                    zones.forEach((item) => {
                        Object.keys(item).forEach((key) => {
                            row.push({
                                CLASS: key,
                                VOLUME: item[key].VOLUME,
                                SPEED: item[key].SPEED,
                                GAP: item[key].GAP,
                                HEADWAY: item[key].HEADWAY,
                                OCCUPANCY: item[key].OCCUPANCY
                            })
                        })
                    })

                    return {
                        asset_id: item["asset_id"],
                        date_iso: item["date_iso"],
                        entries: row
                    }
                })

            const selAsset = assets.find(x => x.id === asset)
            setAssetName(selAsset.name);
            // setAQsensor(selAsset.airscan_id);
            // setCountsh(data)
            setCounts(dataFiltered);

        } else {
            addToast('Error incorrect dates', { appearance: 'error' });
        }
        setIsLoadingCounts(false);

    }

   // Load country
   useEffect(()=>{
    const fetchCountry = async () => {
        let loc = [...new Set(assets.map(item => item.country))];

        loc = loc.filter(item => item !== undefined);
        loc.sort((a, b) => (a > b) ? 1 : -1)

        if (loc.length === 1)
            setCountry(loc[0]);

        setCountryList(loc);
    }
    fetchCountry();

    }, [assets]);

    // Load location
    useEffect(()=>{
    const fetchLocation = async () => {
        let loc=[]
        if (country){
            loc = [...new Set(assets.filter(item => item.country === country).map(item => item.location))];
        }else{
            loc = [...new Set(assets.map(item => item.location))];
        }
        loc.sort((a, b) => (a > b) ? 1 : -1)
        loc = loc.filter(item => item !== undefined);
        setLocationList(loc);
    }
    fetchLocation();
    }, [assets, country]);

    useEffect(() => {
        const handleSearch = () => {
            let results = assets;
            // country
            if (country){
                results = results.filter(results =>
                    results.country && results.country.toLowerCase().includes(country.toLowerCase())
            )}
            // Location
            if (location){
                results = results.filter(results =>
                    results.location && results.location.toLowerCase().includes(location.toLowerCase())
            )}

            setAssetList(results);
        }
		handleSearch();
    }, [location, country, assets]);


    // // Graph options
    const options = {
        maintainAspectRatio: false,
        legend: {
            display: true
        },
        scales: {
            y: { ticks: { beginAtZero: true } },
        },
        plugins: {
            customCanvasBackgroundColor: {
              color: 'lightGreen',
            },
            datalabels: { display: false }
          },
    };


    const handleClearSearch = () => {
		setTimeFrom(new Date().setHours(0,0,0));
        setTimeTo(new Date().setHours(23,59,0));
		// setAsset(assets[0].id);
		setAssetName('');
		setAsset('');
		setDateSel(new Date());
		setDateSelTo(new Date());
        setCounts([]);
        if (countryList.length === 1)
            setCountry(countryList[0]);
        else
            setCountry('');

        setLocation('');
        setVehicleClass({});
        setVehicleClassTbl([]);

    }

    const handleSearch = () => {
        if (asset){
            setCounts([]);
            setRLDdet([]);
            setRLDstat([]);
            fetchCounts();
        }
    }

    const startTime = new Date();
    startTime.setHours(23,59,0);


return (

    <div className="DataReport">
        <div className="col-md-12">
            <div className="row header">Red Light Speed Detector Report</div>
        </div>
        {(!isLoading) ? (
        <div>
        <div className="col-md-12 pt-0 div-content">
        <div className="row">
            <div className="col-12 p-2 d-flex rounded bg-light">
                <div className="col-8">
                <div className="row">
                    <div className="col-md-6">
                        <div className="row">
                        <div className="col-md-4">
                        <Form.Group controlId="country">
                            <Form.Label>Country</Form.Label>
                            <Form.Control
                                as="select"
                                value={country}
                                onChange={e => {setCountry(e.target.value)}}>
                                    <option value="">Country</option>
                                    {countryList.map((item, i) =>
                                        <option key={`country`+i} value={item}>{item}</option>
                                        )}

                            </Form.Control>
                        </Form.Group>
                        </div>
                        <div className="col-md-8">
                        <Form.Group controlId="location" >
                        <Form.Label>Location</Form.Label>
                            <Form.Control
                                as="select"
                                value={location}
                                onChange={e => {setLocation(e.target.value)}}>
                                    <option key='locs' value=''>Location</option>
                                    {locationList.map((item, i) =>
                                        <option key={`loc`+i} value={item}>{item}</option>
                                        )}
                            </Form.Control>
                        </Form.Group>
                        </div>
                        </div>
                        <Form.Group controlId="asset" >
                            <Form.Label>Asset</Form.Label>
                            <Form.Control
                                as="select"
                                value={asset}
                                onChange={e => {setAsset(e.target.value)}}
                                >
                                <option key='assetList' value=''>Asset</option>
                                {assetList.map((item, i) =>
                                <option key={item.id} value={item.id}>{item.name}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                    </div>
                    <div className="col-md-3">
                        <Form.Group controlId="date_from">
                        <Form.Label><FaCalendarAlt className="text-secondary" /> Date</Form.Label>
                        <div>
                        <DatePicker
                            dateFormat={formatDate[1]}
                            selected={dateSel}
                            onChange={(dateSel) => {
                                setDateSel(dateSel); 
                                setDateSelTo(dateSelTo)
                            }}
                            minDate={new Date(moment().add(-1, 'month'))}
                            maxDate={new Date()}
                            className="form-control" />
                        </div>
                        </Form.Group>
                    </div>
                    </div>

                </div>
                <div className="col-2 text-nowrap">

                    <Button variant="info" size="sm" onClick={handleSearch} className="mr-1 text-nowrap"
                    disabled = {isLoadingCounts? true : false}
                    >
                        <MdSearch /> Search
                    </Button>

                    <Button variant="danger" size="sm" onClick={handleClearSearch} >
                        <MdClear />
                    </Button>
                </div>
                <div className="w-100 text-right print">
                        <RedLightSpeedDetXls
                            // totalCount={totalCount}
                            // vehCounts={counts}
                            // busiestDay={busiestDay}
                            // modalTotal={modalTotal}
                            // modalDist={modalDist}
                            // numDays={numDays}
                            dateFrom={dateSel}
                            dateTo={dateSelTo}
                            asset={assetName}
                            vehicleClassTbl={vehicleClassTbl}
                            RLDstat={RLDstat}
                            RLDdet={RLDdet}
                            />
                        <Button variant="light" size="sm" onClick={() => window.print()} >
                            <FaPrint /> Print
                        </Button>
                    </div>
            </div>
            </div>
            {/* a) Vehicle classification and volume of all detected vehicles travelling through junction – (single detection only) */}
            {/* stats excluding peds */}
           {/* <br/> b) Initial speed profile (accelerating / decelerating for each signal display – RAG)  of all vehicles detected, this will assist understanding of behaviour – (multiple detections of same vehicle) */}
           {/* <br/> c) Speed of each vehicle entering detection zone – see b) above */}
           {/* only red light, 1st record of the veh or 1st and last */}
           {/* <br/> d) Date and time of vehicle red-light violations */}
           {/* from dilemma stats and det from obj list */}
           
           <div className="row">
                <div className="col-md-6">
                <DetZone
                    // options={options}
                    assetName={assetName}
                    isLoadingCounts={isLoadingCounts}
                    asset={asset}
                    dateSel={dateSel}
                    dateSelTo={dateSelTo}
                    timeFrom={timeFrom}
                    timeTo={timeTo}
                    params={params}
                    addToast={addToast}
                    RLDstat={RLDstat}
                    setRLDstat={setRLDstat}
                    RLDdet={RLDdet}
                    setRLDdet={setRLDdet}
                    />
                </div>
                <div className="col-md-6">
                {/* Vehicle Class */}
                <VehClass
                    vehicleClass={vehicleClass}
                    options={options}
                    assetName={assetName}
                    vehicleClassTbl={vehicleClassTbl}
                    setVehicleClass={setVehicleClass}
                    setVehicleClassTbl={setVehicleClassTbl}
                    counts={counts}
                    chartColors={chartColors}
                    />
                </div>
            </div>
            </div>
        </div>
        ):(
            <div className="col-md-12">
            <Spinner animation="grow" size="sm" role="status" variant="warning" />
            <span className="text-dark">  Loading...</span>
            </div>
            )}
    </div>
)
}


const mapStateToProps = state => {
    return {
        user: state.auth.user,
        formatDate: state.auth.formatDate,
    };
  };

export default connect(mapStateToProps)(RedLightSpeedDet);


